
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import PapaParse from "papaparse";
import { EventBus } from "./../helpers/EventBus";
import mime from "mime-types";

@Component({
  components: {
    Datepicker,
  },
})
export default class Issues extends Vue {
  public isBusy = false;
  public filter: string = "";
  public dateFrom: string = "";
  public dateTo: string = "";
  public hostname: string = "";
  public issueComment: string = "";
  public fields = [
    {
      key: "Status",
      label: "",
    },
    {
      key: "ReportedAt",
      sortable: true,
      formatter: (value) => {
        return moment(value).format("lll");
      },
    },
    {
      key: "Description",
      sortable: true,
    },
    {
      key: "Disposition",
      sortable: true,
    },
    {
      key: "VersionInfo",
      sortable: true,
    },
    {
      key: "Reported-By",
      sortable: true,
    },
    {
      key: "LogLines",
      sortable: true,
    },
  ];
  public totalRows = 1;
  public currentPage = 1;
  public perPage = 20;
  public pageOptions = [5, 10, 15];
  public issues: any[] = [];
  public rowCount = 0;
  public issueFilter = ["All", "Open","In Progress", "Closed"];
  public issueStatusFilter = "All";
  public isPagingBusy = false;
  public mounted() {
    this.hostname = Vue.prototype.$hostMode;

    EventBus.$on("mode-changed", this.modeChanged);

    document
      .querySelectorAll(".table-container")
      .forEach((el) => el.addEventListener("scroll", this.tableFixHead));
  }

  public modeChanged(mode) {
    this.hostname = mode;
    this.refreshIssues();
  }

  public beforeDestroy() {
    EventBus.$off("mode-changed", this.modeChanged);
  }

  public refreshIssues() {
    (this.$refs.issuesTable as any).refresh();
  }

  public clickOnAttachment(mediaType, base64Data, name) {
    const url = window.URL.createObjectURL(
      this.b64toBlob_(base64Data, mediaType)
    );
    const link = document.createElement("a");
    var suffix = mime.extension(mediaType);
    if (!suffix) {
      suffix = "";
    }
    if (!suffix.startsWith(".")) {
      suffix = "." + suffix;
    }
    if (name.toLowerCase().endsWith(suffix.toLowerCase())) {
      suffix = "";
    }
    link.href = url;
    link.setAttribute("download", `${name}${suffix}`);
    document.body.appendChild(link);
    link.click();
  }

  public loadIssues(ctx) {
    console.log("ddd ",ctx);
    const paginate = true;
    const limit = this.perPage ? this.perPage :20;
    const skip = (this.currentPage - 1) * this.perPage ?(this.currentPage - 1) * this.perPage : 0 ;
    const sortBy = `&sortBy=${ctx.sortBy}&sortDirection=${
      ctx.sortDesc ? "descending" : "ascending"
    }`;
    console.log('sortBy::: ',sortBy);
    //const paginationFilter = `limit=${limit}&skip=${skip}`;
    const paginationFilter = paginate ? `limit=${limit}&skip=${skip}&` : "";

    this.isBusy = true;
    const client = this.hostname === "ers" ? "ERSPowerPoint" : "GenieBot";
    let url = `/api/v4/Client/ErrorReports/${client}`;

    // grap explicitly interesting fields
    url += "?result-attribute=ID";
    url += "&result-attribute=ReportedAt";
    url += "&result-attribute=Description";
    url += "&result-attribute=Disposition";
    url += "&result-attribute=VersionInfo";
    url += "&result-attribute=LogLines";
    url += "&result-attribute=Reported-By";
    url += "&result-attribute=Disposition";
    url += "&result-attribute=Attachments";
    url += `&issueStatusFilter=${this.issueStatusFilter}`

    axios.get(url).then((response) => {
        this.isBusy = false;

        const filteredIssues = response.data.filter(e => {
          const disposition = e.Disposition != null ? e.Disposition : ""; 
        if (this.issueStatusFilter === "Open") {
            return disposition === "";
        } else if (this.issueStatusFilter === "Closed") {
            return disposition && disposition !== "" && disposition !== "In Progress";
        } else if (this.issueStatusFilter === "In Progress") {
            return disposition === "In Progress"; 
        }
        return true;
    });

        this.issues = filteredIssues;
        this.rowCount = filteredIssues.length;
    });
    url+= `&${paginationFilter}${sortBy}`;

    return axios.get(url).then(
      (response) => {
        this.issues = response.data
          .map((e) => {
            e.Status =
              e.Disposition && e.Disposition !== "" && e.Disposition!=="In Progress" ? "Closed" : e.Disposition=="In Progress"?"In Progress": "Open";
            let summary = "";
            let attachments = null;
            for (const k of Object.keys(e)) {
              const v = e[k];
              if (k === "LogLines" && e.LogLines.length > 0) {
                summary += `<br/><span class="issue-detail-summary"><b>${k}:</b> <br/>&nbsp;&nbsp;-&nbsp;&nbsp;${v.join(
                  "<br/>&nbsp;&nbsp;-&nbsp;&nbsp;"
                )}</span>`;
              } else if (k === "Attachments") {
                // Skip that field - handled in the template
              } else {
                summary += `<br/><span class="issue-detail-summary"><b>${k}:</b> ${v}</span>`;
              }
            }
            e.FullItemSummary = summary;

            const oldItem = this.issues.find((i) => i.ID === e.ID);
            e._showDetails = oldItem && oldItem._showDetails ? true : false;

            return e;
          })
          .filter((e) => {
            if (
              this.issueStatusFilter !== "All" &&
              this.issueStatusFilter !== e.Status
            ) {
              return false;
            }
            return true;
          });
        this.isBusy = false;
        //this.rowCount = this.issues.length;
        return this.issues;
      },
      (error) => {
        console.error(error);
      }
    );
  }
  public customFormatter(date) {
    return moment(date)
      .toISOString()
      .split("T")[0];
  }

  public tableSortCompare(a, b, key) {
    if (key === "ReportedAt") {
      // Assuming the date field is a `Date` object, subtraction
      // works on the date serial number (epoch value)
      const t1 = new Date(a[key]).getTime();
      const t2 = new Date(b[key]).getTime();
      return t1 - t2;
    } else {
      // Let b-table handle sorting other fields (other than `date` field)
      return false;
    }
  }

  public tableFixHead(e) {
    const el = e.target;
    const sT = el.scrollTop;
    el.querySelectorAll("thead th").forEach(
      (th) => (th.style.transform = `translateY(${sT}px)`)
    );
  }

  public rowSelected(row) {
    row._showDetails = !row._showDetails;
  }
  public doDownload(logLines) {
    const delimiter = String.fromCharCode(9);

    const txt = logLines.join("\r\n\r\n");

    const url = window.URL.createObjectURL(
      new Blob([txt], { type: "text/plain" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ERS exported log data.txt`);
    document.body.appendChild(link);
    link.click();
  }

  public onFiltered(filteredItems) {
    this.rowCount = filteredItems.length;
    this.currentPage = 1;
  }

  public statusUpdated(e, id) {
    const b = [
      {
        op: "replace",
        path: "/Disposition",
        value: e === "Closed" ? this.issueComment :e==="In Progress"?"In Progress": null,
      },
    ];
    // this.isBusy = true;
    const client = this.hostname === "ers" ? "ERSPowerPoint" : "GenieBot";
    const url = `/api/v4/Client/ErrorReport/${client}/${id}`;

    axios
      .patch(url, b)
      .then((response) => {
        this.refreshIssues();

        this.makeToast("Issue " + e);
      })
      .catch((error) => {
        this.isBusy = false;
        this.makeToast("Error while trying to close Issue", "danger");
      });
  }

  public makeToast(msg, vrant = "success") {
    this.$bvToast.toast(`${msg}`, {
      title: "Operation Completed",
      autoHideDelay: 3000,
      variant: vrant,
      appendToast: false,
    });
  }

  private b64toBlob_(base64Data, contentType = "") {
    contentType = contentType || "";
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);
      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }
}
